import { FC } from 'react'
import { Card } from '@aptive-env/storybook'
import ImageLayers from 'assets/image/layers.png'
import ImageRoute from 'assets/image/route.png'

type RouteLayersToggleButtonProps = {
  onClick: () => void
}

export const RouteLayersToggleButton: FC<RouteLayersToggleButtonProps> = ({
  onClick
}) => {
  return (
    <Card
      className="h-[80px] w-[80px] bg-ui-snow rounded-lg shadow-med p-[2px] cursor-pointer"
      onClick={onClick}
    >
      <div
        className="h-full rounded-lg flex flex-col items-center justify-center"
        style={{ background: 'linear-gradient(180deg, rgba(217, 217, 217, 0.00) 0%, rgba(4, 4, 4, 0.80) 100%)' }}
      >
        <div className="flex items-center justify-center">
          <img src={ImageRoute} alt="ImageRoute" />
        </div>
        <div className="flex items-center justify-center w-full">
          <img src={ImageLayers} alt="ImageLayers" />
          <span
            className="ml-1 font-bold text-white text-xs"
            style={{ textShadow: '0px 1px 0px rgba(0, 0, 0, 0.80)'}}
          >
            Route
          </span>
        </div>
      </div>
    </Card>
  )
}
